import { FactoryTypes, FieldID, GuideTypes } from "../models";
import { FlowTypes, MobileDeviceValues } from "@trailhead/smart-setup-core";
import {
  androidToiPhoneSetupLostPhone,
  androidToSamsungSetupLostPhone,
  androidToSamsungSetupWithPhone,
  backupAndroidContent,
  backupIphone,
  iphoneSetupContentWithPhone,
  iphoneToAndroidSetupWithPhone,
  iphoneToIphoneSetupLostPhone,
  iphoneToIphoneSetupWithPhone,
  iphoneToSamsungSetupWithPhone,
  samsungToAndroidLostPhone,
  samsungToAndroidWithPhone,
  telusKoodoIphoneToAndroidSetupLostPhone,
  telusKoodoIphoneToSamsungSetupLostPhone,
} from "./common";
import {
  telusKoodoActivationContent,
  telusKoodoActivationContentIPhoneToAndroid,
  telusKoodoIPhoneSendBackContent,
  telusKoodoSendBackContent,
} from "./telus";

const koodoActivationStep = {
  type: FactoryTypes.NUMBERED_STEP,
  fieldMapping: {
    text: FieldID.guideContainer.steps.koodoPhoneActivationStep.text,
  },
};

export const KoodoContent = {
  [GuideTypes.BACKUP]: [
    {
      criteria: {
        oldPhone: MobileDeviceValues.iPhone,
      },
      content: backupIphone,
    },
    backupAndroidContent(MobileDeviceValues.Samsung),
    backupAndroidContent(MobileDeviceValues.OtherAndroid),
    backupAndroidContent(MobileDeviceValues.Pixel),
  ],
  [GuideTypes.ACTIVATE]: [
    {
      criteria: {
        oldPhone: MobileDeviceValues.iPhone,
        newPhone: MobileDeviceValues.OtherAndroid,
        newDeviceActivated: false,
      },
      content: telusKoodoActivationContentIPhoneToAndroid([
        koodoActivationStep,
      ]),
    },
    telusKoodoActivationContent([koodoActivationStep]),
  ],
  [GuideTypes.SETUP]: [
    {
      criteria: {
        oldPhone: MobileDeviceValues.iPhone,
        newPhone: MobileDeviceValues.iPhone,
        oldDeviceFunctional: true,
      },
      content: iphoneToIphoneSetupWithPhone,
    }, //iphone to iphone with phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.iPhone,
        newPhone: MobileDeviceValues.iPhone,
        oldDeviceFunctional: false,
      },
      content: iphoneToIphoneSetupLostPhone,
    },
    {
      criteria: {
        oldPhone: MobileDeviceValues.iPhone,
        newPhone: MobileDeviceValues.Samsung,
        oldDeviceFunctional: true,
      },
      content: iphoneToSamsungSetupWithPhone,
    }, //iphone to samsung with phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.iPhone,
        newPhone: MobileDeviceValues.Samsung,
        oldDeviceFunctional: false,
      },
      content: telusKoodoIphoneToSamsungSetupLostPhone,
    }, //iphone to samsung lost phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.iPhone,
        newPhone: MobileDeviceValues.OtherAndroid,
        oldDeviceFunctional: true,
      },
      content: iphoneToAndroidSetupWithPhone,
    }, //iphone to android with phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.iPhone,
        newPhone: MobileDeviceValues.OtherAndroid,
        oldDeviceFunctional: false,
      },
      content: telusKoodoIphoneToAndroidSetupLostPhone,
    }, //iphone to android lost phone

    //--------------------------------------------

    {
      criteria: {
        oldPhone: MobileDeviceValues.Samsung,
        newPhone: MobileDeviceValues.Samsung,
        oldDeviceFunctional: true,
      },
      content: androidToSamsungSetupWithPhone,
    }, //samsung to samsung with phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.Samsung,
        newPhone: MobileDeviceValues.iPhone,
        oldDeviceFunctional: true,
      },
      content: iphoneSetupContentWithPhone,
    }, //samsung to iphone with phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.Samsung,
        newPhone: MobileDeviceValues.OtherAndroid,
        oldDeviceFunctional: true,
      },
      content: samsungToAndroidWithPhone,
    }, //samsung to android with phone

    {
      criteria: {
        oldPhone: MobileDeviceValues.OtherAndroid,
        newPhone: MobileDeviceValues.iPhone,
        oldDeviceFunctional: true,
      },
      content: iphoneSetupContentWithPhone,
    }, //android to iphone with phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.OtherAndroid,
        newPhone: MobileDeviceValues.Samsung,
        oldDeviceFunctional: true,
      },
      content: androidToSamsungSetupWithPhone,
    }, //android to samsung with phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.OtherAndroid,
        newPhone: MobileDeviceValues.OtherAndroid,
        oldDeviceFunctional: true,
      },
      content: samsungToAndroidWithPhone,
    }, //android to android with phone

    {
      criteria: {
        newPhone: MobileDeviceValues.iPhone,
        oldDeviceFunctional: false,
      },
      content: androidToiPhoneSetupLostPhone,
    }, //x to iphone
    {
      criteria: {
        oldPhone: MobileDeviceValues.OtherAndroid,
        newPhone: MobileDeviceValues.Samsung,
        oldDeviceFunctional: false,
      },
      content: androidToSamsungSetupLostPhone,
    }, //android to samsung WITHOUT phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.Samsung,
        newPhone: MobileDeviceValues.Samsung,
        oldDeviceFunctional: false,
      },
      content: androidToSamsungSetupLostPhone,
    }, //samsung to samsung WITHOUT phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.Samsung,
        newPhone: MobileDeviceValues.OtherAndroid,
        oldDeviceFunctional: false,
      },
      content: samsungToAndroidLostPhone,
    }, //samsung to android WITHOUT phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.OtherAndroid,
        newPhone: MobileDeviceValues.OtherAndroid,
        oldDeviceFunctional: false,
      },
      content: samsungToAndroidLostPhone,
    }, //android to android WITHOUT phone
  ],
  [GuideTypes.SEND_BACK]: [
    {
      criteria: {
        oldPhone: MobileDeviceValues.iPhone,
        oldDeviceAccess: true,
        deviceFlowType: FlowTypes.Replacement,
      },
      content: telusKoodoIPhoneSendBackContent,
    },
    telusKoodoSendBackContent,
  ],
};
